
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-1 0 17 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M13.336 11.667c-.888 0-1.384.287-1.744.497-.296.18-.48.28-.92.28-.44 0-.624-.108-.92-.28-.36-.21-.856-.497-1.744-.497s-1.384.287-1.752.497c-.296.18-.472.28-.92.28-.448 0-.624-.1-.92-.28-.36-.21-.856-.497-1.744-.497s-1.384.287-1.752.497c-.296.18-.472.28-.92.28V14c.888 0 1.384-.288 1.752-.498.296-.179.48-.28.92-.28.44 0 .624.101.92.28.36.21.856.498 1.744.498s1.384-.288 1.752-.498c.296-.179.472-.28.92-.28.44 0 .624.11.92.28.36.21.856.498 1.744.498s1.376-.288 1.744-.498c.296-.179.472-.28.92-.28.44 0 .624.11.92.28.36.21.856.498 1.744.498v-1.556c-.448 0-.624-.1-.92-.28-.36-.21-.856-.497-1.744-.497zM2.68 9.722c.44 0 .624.11.92.28.36.21.856.498 1.744.498s1.384-.288 1.744-.498c.296-.179.472-.28.92-.28.44 0 .624.11.92.28.36.21.856.498 1.744.498s1.384-.288 1.744-.498c.296-.179.472-.28.92-.28.44 0 .624.11.92.28.36.21.848.49 1.728.498V8.944c-.44 0-.624-.108-.92-.28-.36-.21-.856-.497-1.744-.497s-1.384.287-1.744.497c-.296.18-.48.28-.92.28-.44 0-.624-.108-.92-.28-.36-.21-.856-.497-1.744-.497s-1.384.287-1.744.497c-.296.18-.472.28-.92.28-.44 0-.624-.108-.92-.28-.36-.21-.856-.497-1.744-.497S1.28 8.454.92 8.664c-.296.18-.472.28-.92.28V10.5c.888 0 1.384-.288 1.76-.498.296-.179.48-.28.92-.28zm13.304.778H16M6.4 3.889L3.8 6.417c.248.093.448.21.616.303.296.179.472.28.92.28.448 0 .624-.101.92-.28.368-.21.864-.498 1.752-.498s1.384.288 1.744.498c.296.171.48.28.92.28.44 0 .624-.101.92-.28a9.94 9.94 0 01.328-.179L6.784 1.556C5.544.35 4.4-.008 2.4 0v1.944c1.456-.007 2.312.304 3.2 1.167zM9.053 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"}})])
          )
        }
      }
    